import {
  Component,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
  ViewChild,ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import {
  Subscription,
} from 'rxjs';
import { Router } from '@angular/router';
import { ChatServices } from '@app/services/chat.service';
import { PrimeNGConfig, MessageService } from 'primeng/api';
import { IChat } from '@common/models/Chat/IChat';
import { IDocument } from '@common/models/Document/IDocument';
import { IChatDocument } from '@common/models/Chat/IChatDocument';
import { HttpStatusCodes } from '@common/enums/HttpStatusCodes';
import { InteractionType } from '@common/enums/InteractionType';
import { IChatInteraction } from '@common/models/Chat/IChatInteraction';
import { DocumentStatus } from '@common/enums/DocumentStatus';
import { DocumentAccessLevel } from '@common/enums/DocumentAccessLevel';
import { SummaryStatus } from '@common/enums/SummaryStatus';
import { ChatType } from '@common/enums/ChatType';
import { IChatMetaData } from '@common/models/Chat/IChatMetaData';
import { DocumentService } from '@app/services/document.service';
import { IAddDoctoChatAPIResp } from '@common/models/Chat/IAddDoctoChatAPIResp';
import { IDeltaTable } from '@common/models/Document/IDeltaTable';
import { IESGDocuments, ISourceURL} from '@common/models/Document/IESGDocuments';
import { ITableTag } from "@common/models/ITags";
import { IChatConfig, IESGConfig } from '@common/models/Chat/IChatConfig';
import { UploadType } from '@common/enums/UploadType';
import { ChatState } from '@common/enums/ChatState';
import { ALL_DOCUMENT_FILE_FORMATS, CSV_FILE_FORMATS, EXCEL_FILE_FORMATS } from '@common/constants';
import { getRouteParamChatType } from '@app/utils';
@Component({
  selector: 'app-chat-document',
  templateUrl: './chat-document.component.html',
  styleUrls: ['./chat-document.component.scss'],
  providers: [MessageService],
})
export class ChatDocumentComponent implements OnInit, OnDestroy  {
  constructor(
      private readonly chatServices: ChatServices,
      private readonly docService : DocumentService,
      private readonly messageService: MessageService,
      private readonly primengConfig: PrimeNGConfig,
      private readonly cdr: ChangeDetectorRef,
      public router: Router,
  ) {}
  files: File[] = [];
  identicalHashFiles: File[] = [];
  searchloading: boolean = false;
  filteredItems: IChatDocument[];
  selectedDocs: IChatDocument[];
  activeChat: IChat;
  isSearchLoading: boolean = false;
  searchText: string;
  sidebarVisible: boolean = false;
  uploadSub: Subscription = new Subscription();
  updateChatsSub: Subscription = new Subscription();
  getChatDocsSub: Subscription = new Subscription();
  getDeltaTableDocsSub: Subscription = new Subscription();
  longPollSub: Subscription = new Subscription();
  deleteDocsSub: Subscription = new Subscription();
  createChatSub: Subscription = new Subscription();
  getAllDocsSub: Subscription = new Subscription();
  docSummarySub: Subscription = new Subscription();
  chatSubscription: Subscription = new Subscription();
  hrDocsSubscription: Subscription = new Subscription();
  getESGTableTagsSubscription: Subscription = new Subscription();
  displayDialogType: string;
  displayConfirmationDialog: boolean = false;
  dialogMessage: string;
  deletingDoc: IChatDocument;
  deletingDocIndex: number;
  documentsList: IDocument[] = [];
  isloading: boolean = true;
  documentStatusActive: DocumentStatus = DocumentStatus.Processed;
  documentStatusTextOnly: DocumentStatus = DocumentStatus.TextOnly;
  documentStatusFailed: DocumentStatus = DocumentStatus.Failed;
  retriggerDoc: IDocument;
  retriggerDocIndex: number;
  documentStatusProcessing: DocumentStatus = DocumentStatus.Processing;
  documentStatusConverting: DocumentStatus = DocumentStatus.Converting;
  documentStatusDelete: DocumentStatus = DocumentStatus.Deleted;
  documentArchived: DocumentStatus = DocumentStatus.Archived;
  displayCSVUploadDialog: boolean = false;
  addingCSVDocLoader: boolean = false;
  CSVFiles: IDocument[] = [];
  CSVFilesCopy: IDocument[] = [];
  displayExcelInfoDialog: boolean = false;
  summaryDialogVisible:boolean = false;
  summaryData = '';
  headerSummary = '';
  dialogType: 'table' | 'document';
  summaryDocumentName = '';
  tableSummaryForSidebar: IDeltaTable;
  documentModelForSummary: IDocument;
  updateChatTablesSub: Subscription = new Subscription();
  
  excelType = EXCEL_FILE_FORMATS;
  csvType=CSV_FILE_FORMATS;
  isdocuploaded : boolean = false;
  CSVTablesData : any = []
  @ViewChild('fileUpload') fileUpload: ElementRef;
  @Output() reloadInteractions: EventEmitter<string> = new EventEmitter();
  @Output() chatDocsProcessingCount: EventEmitter<number> = new EventEmitter();
  ESGChatType= ChatType.ESG
  codeInterpreterChatType= ChatType.codeInterpreter
  agenticWorkflowChatType= ChatType.agenticWorkflow
  hrDocumentsChatType = ChatType.HRDocuments
  QECChatType = ChatType.QEC
  VanillaChatType = ChatType.Normal
  DocumentChatType = ChatType.UnstructuredDocument
  StructuredDocChatType = ChatType.StructuredDocument
  chatInteractionCount = 0;
  ESGDocumentLoaderDocs : Record<number,boolean> = {}
  tablesLoaderDocs : Record<number,boolean> = {}
  ESGDeletionLoaderTags : Record<number,boolean> = {}
  ESGDeletionLoaderSources : Record<number,boolean> = {}
  isTablesCollapsed: boolean = false;
  hrDocuments:IChatDocument[]=[]
  countDocProcessing:number = 0;
  isUploading: boolean = false;
  uploadQueue: { file: File, force: boolean }[] = [];
  private readonly chatUpdateQueue: (() => void)[] = [];
  pollingSet = new Set();
  Math = Math;
  statusLabelMap: Record<DocumentStatus, string> = {
    [DocumentStatus.Processing]: 'Processing',
    [DocumentStatus.Converting]: 'Converting',
    [DocumentStatus.Processed]: 'Processed',
    [DocumentStatus.Failed]: 'Failed',
    [DocumentStatus.Deleted]: 'Deleted',
    [DocumentStatus.Archived]: 'Archived',
    [DocumentStatus.TextOnly]: 'Text Only'
  };
  structuredDocumentsList: IDocument[] = [];
  unStructuredDocumentsList: IDocument[] = [];

  ngOnInit(): void {
    this.primengConfig.ripple = true;
    this.isloading = true;
    this.chatSubscription = this.chatServices
        .getActiveChatObs()
        .subscribe((res: IChat) => {
            if (res?.chatId) {
                if (
                    this.activeChat != undefined &&
                    this.activeChat?.chatId == res?.chatId
                ) {
                    this.activeChat = res;
                }
                else {
                    this.activeChat = res;
                    this.reloadInteractions.emit('showLoader');
                    this.getChatDocuments();
                }
            } else {
                this.activeChat = undefined;
                this.documentsList = [];
                this.getProcessingDocsCount()

            }
        });
    if (this.activeChat == undefined) {
        this.activeChat = this.chatServices.getActiveChat();
        if (this.activeChat?.chatId) {
            this.getChatDocuments();
        }
    }
}

get defaultWFDOTables() {
    return this.docService.defaultWFDOTables;
}

get currentChatType() {
    return this.chatServices.chatType;
}

get currentActiveChat() {
    return this.chatServices.getActiveChat();
}

get isMixedDocumentsPresent(){
    let isStructuredDocPresent = false;
    let isUnStructuredDocPresent = false;

    let structuredDocList: IDocument[] = [];
    let unstructuredDocList: IDocument[] = []
    
    for(let document of this.documentsList) {
        if(this.excelType.includes(document.contentType) || this.csvType.includes(document.contentType)){
            isStructuredDocPresent = true;
            structuredDocList.push(document);
        } else {
            isUnStructuredDocPresent = true;
            unstructuredDocList.push(document);
        }

    }

    this.structuredDocumentsList = structuredDocList;
    this.unStructuredDocumentsList = unstructuredDocList;

    return isStructuredDocPresent && isUnStructuredDocPresent;
}

get isAnyDocumentImageProcessing(): boolean {
  return this.documentsList?.some(dl => dl.documentStatus === this.documentStatusTextOnly);
}

toggleTablesCollapse(tableDataLength: number): void {
    if (tableDataLength > 3) {
        this.isTablesCollapsed = !this.isTablesCollapsed;
    }
}

updateSidebar(value: boolean) {
  this.summaryDialogVisible = value;
  if(this.summaryDialogVisible===false){
    this.summaryData=null
  }
}

async openSummaryDialog(dataModel : IDocument | IDeltaTable,index:number){
  this.headerSummary = 'Data Dictionary';
  this.dialogType = 'table';
  this.tablesLoaderDocs[index]=true
  if('documentName' in dataModel){
    this.summaryDialogVisible = true;
    this.summaryDocumentName = dataModel.documentName
    this.documentModelForSummary = dataModel
    this.tablesLoaderDocs[index]=false
  }else{
    this.summaryDocumentName = dataModel.tableName
    this.getDeltaTableDocsSub = this.chatServices
    .getDeltaTableById(dataModel.tableId)
    .subscribe({
        next: (res: IDeltaTable) => {
          this.tableSummaryForSidebar = res
          this.summaryDialogVisible = true;
          this.tablesLoaderDocs[index]=false
        }
    });
  }
}

async openESGSummary(dataModel:ISourceURL,idx:number){
  this.ESGDocumentLoaderDocs[idx]= true
  this.getDeltaTableDocsSub = this.chatServices
  .getESGDocumentByID(dataModel.documentId)
  .subscribe({
      next: (res: IESGDocuments) => {
        this.ESGDocumentLoaderDocs = {}
        this.summaryData = structuredClone(res.documentSummary);
        this.headerSummary = 'Summary';
        this.dialogType = 'document';
        this.summaryDocumentName = dataModel.documentName
        this.tableSummaryForSidebar=null
        this.summaryDialogVisible = true;
        this.tableSummaryForSidebar=null
        this.documentModelForSummary=null
        this.cdr.detectChanges();
      }
  });
}

  closeDocsSideBar(event: boolean) {
      this.sidebarVisible = false;
  }

  closeInFoSlider(event: boolean) {
    this.displayExcelInfoDialog = false;
  }

  attachChatstoDocs(chatDocs:IChatDocument[]){
    // Preserve existing chatDocument metaData & generatedSummary if not provided
    const existingDocs = this.activeChat?.chatDocument || [];
    const existingIds = new Set(existingDocs.map(d=>d.documentId));
    const incomingMap = new Map<string, IChatDocument>();
    chatDocs.forEach(d => incomingMap.set(d.documentId, d));

    const mergedInitial: IChatDocument[] = Array.from(incomingMap.values()).map(d => {
      const prev = existingDocs.find(p => p.documentId === d.documentId);
      if(prev){
        return {
          ...d,
          metaData: (d.metaData && d.metaData.length>0) ? d.metaData : prev.metaData,
          generatedSummary: d.generatedSummary ?? prev.generatedSummary
        };
      }
      return d;
    });

    let temp_activeChatDocs = this.documentsList;
      let docsUploaded: IDocument[] = temp_activeChatDocs?.filter(
          (doc) => doc.documentId != ''
      );
      let docspayload: IChatDocument[] = []
      docsUploaded?.forEach(
          (ele: IDocument) => {
            if(!mergedInitial.some(doc=>doc.documentId === ele.documentId)){
              let prev = existingDocs.find(p=>p.documentId===ele.documentId);
              let doc: IChatDocument = {
                documentId: ele.documentId,
                documentName: ele.documentName,
                contentType: ele.contentType,
                metaData: prev?.metaData,
                generatedSummary: prev?.generatedSummary
            };
            docspayload.push(doc);
            }
          }
      );
      const finalPayload = [...mergedInitial,...docspayload];
      // Track new documents (those not previously in chat)
      const newDocIds = new Set(finalPayload.filter(d=>!existingIds.has(d.documentId)).map(d=>d.documentId));
      this.reloadInteractions.emit('showLoader');
      this.updateChatsSub?.unsubscribe()
      this.updateChatsSub = new Subscription()
      this.updateChatsSub.add(
          this.chatServices
              .updateChatDocuments(
                  finalPayload,
                  this.activeChat.chatId
              )
              .subscribe({
                  next: (res:IAddDoctoChatAPIResp) => {
                    if(this.isdocuploaded ){
                      this.reloadInteractions.emit('summary');
                      if(res?.data?.chatDocument?.length > 0){
                        this.reloadInteractions.emit('loadChatHistory');
                      }
                    }
                      this.isdocuploaded = false
                      this.activeChat = res?.data;
                      this.getChatDocuments();
                      this.chatServices.updateActiveChatObs(res?.data);
                      this.chatServices.updateActiveChat(res?.data);
                      // Only long-poll new docs to avoid duplicate summary generations
                      res?.data?.chatDocument
                        .filter((e:IChatDocument)=> newDocIds.has(e.documentId))
                        .forEach((e:IChatDocument)=>{ this.longPollDocs(e.documentId,this.activeChat) });
                      if(res?.message?.trim() != '' ){
                        this.messageService.clear();
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: res?.message,
                        });
                      }
                  },
                  error: (error) => {
                      this.messageService.clear();
                      this.messageService.add({
                          severity: 'error',
                          summary: 'Error',
                          detail: error.error.message,
                      });
                  },
              })
      );
  }

  cancelCSVUpload(){
    this.CSVFilesCopy.forEach((csv:IDocument)=>{
      this.documentsList.forEach((e:IDocument,index:number)=>{
        if(csv.documentId == e.documentId && csv.structuredDocumentStatus!=DocumentStatus.Processed){
          this.documentsList.splice(index, 1);
          this.getProcessingDocsCount()
        }
      })
    })
    this.CSVFilesCopy = [];
  }

  updateSelectedDeltaTablesFromSidebar(selectedTables:IDeltaTable[]){
    if (this.sidebarVisible) {
      this.isloading = true
        this.sidebarVisible = false;
        this.CSVFiles=[]
        if (this.activeChat?.chatId) {
            this.isdocuploaded = true;
            this.attachDeltaTableToChat(selectedTables)
        }
        else if (selectedTables.length > 0) {
            this.chatServices.updateChatTypeStatus(this.currentChatType === ChatType.ESG ?ChatType.ESG :ChatType.QEC)
            this.createChatSub.add(
                this.chatServices.createNewChat().subscribe({
                    next: (res: IChat) => {
                        this.activeChat = res;
                        // this.activeChat.chatDocument = selectedDocs
                        this.chatServices.updateActiveChat(
                            this.activeChat
                        );
                        this.isdocuploaded = true;
                        this.attachDeltaTableToChat(selectedTables)
                        this.router.navigate(['/chat', getRouteParamChatType(this.currentChatType), this.activeChat.chatId]);

                    },
                    error: (error) => {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: error.error.message,
                        });
                    },
                })
            );
        }
    }
  }

  attachDeltaTableToChat(chatTables:IDeltaTable[]){
    this.updateChatsSub?.unsubscribe()
    this.updateChatsSub = new Subscription()
    this.updateChatsSub.add(
        this.chatServices
            .updateChatDocuments([],
                this.activeChat.chatId,
                chatTables
            )
            .subscribe({
                next: (res) => {
                    this.activeChat = res?.data;
                    this.chatServices.updateActiveChatObs(res?.data);
                    this.chatServices.updateActiveChat(res?.data);
                   this.isloading = false
                },
                error: (error) => {
                    this.isloading = false
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error.error.message,
                    });
                },
            })
    );
  }


  getDocStatusClass(rowData: IDocument) {
      if (rowData.documentStatus) {
          if (rowData.documentStatus === DocumentStatus.Processing || rowData.documentStatus === DocumentStatus.Converting) {
              return 'chip-processing';
          } else if (rowData.documentStatus === DocumentStatus.Processed) {
              return 'chip-completed';
          } else if (rowData.documentStatus === DocumentStatus.Failed) {
              return 'chip-failed';
          } else if (rowData.documentStatus === DocumentStatus.Deleted) {
              return 'chip-delete';
          } else {
              return 'chip-new';
          }
      } else {
          return 'chip-new';
      }
  }

  openSidebar() {
      this.sidebarVisible = true;
  }

  removeDuplicates(arr1: any[], arr2: any[]) {
      const uniqueIds = new Set(arr1.map((item) => item.documentId));
      // Filter the second array to include only items with unique documentIds
      const filteredSecondArray = arr2.filter(
          (item) => !uniqueIds.has(item.documentId)
      );
      // Concatenate the first array with the filtered second array
      return arr1.concat(filteredSecondArray);
  }

  ngOnDestroy() {
      this.deleteDocsSub?.unsubscribe();
      this.createChatSub?.unsubscribe();
      this.hrDocsSubscription?.unsubscribe();
      this.getAllDocsSub?.unsubscribe();
      this.getChatDocsSub?.unsubscribe();
      this.getDeltaTableDocsSub?.unsubscribe();
      this.chatSubscription?.unsubscribe();
      this.longPollSub?.unsubscribe();
      this.getESGTableTagsSubscription?.unsubscribe();
      this.updateChatTablesSub?.unsubscribe();
  }

  fileSelect(event: Event) {
      event.preventDefault();
      event.stopPropagation();
      const inputElement = event.target as HTMLInputElement;
      if (inputElement.files && inputElement.files.length > 0) {
          if (inputElement.files.length > 10) {
              this.messageService.clear();
              this.messageService.add({
                  severity: 'error',
                  summary: 'File Limit Exceeded',
                  detail: 'You can upload a maximum of 10 files at a time.',
              });
              inputElement.value = '';
              return;
          }
          let temp_files = Array.from(inputElement.files);
          temp_files.forEach((e: File) => {
              if (ALL_DOCUMENT_FILE_FORMATS.includes(e.type) ) {
                    this.files = [...this.files, e];
              } else {
                  this.messageService.clear();
                  this.messageService.add({
                      severity: 'warn',
                      summary: 'File Type',
                      detail: 'Only .pptx/ .docx/ .pdf/ .txt/ .xls/ .xlsx/.csv files are allowed',
                  });
              }
          });
      }
      if (this.files.length > 0) {
          this.saveFile();
      }
  }

  fileSelectOnDrag(event: DragEvent) {
      event.preventDefault();
      event.stopPropagation();
      const inputElement = event.dataTransfer as unknown as HTMLInputElement;
      if (inputElement.files && inputElement.files.length > 0) {
          if (inputElement.files.length > 10) {
              this.messageService.clear();
              this.messageService.add({
                  severity: 'error',
                  summary: 'File Limit Exceeded',
                  detail: 'You can upload a maximum of 10 files at a time.',
              });
              return;
          }
          let temp_files = Array.from(inputElement.files);
          temp_files.forEach((e: File) => {
              if (ALL_DOCUMENT_FILE_FORMATS.includes(e.type) ) {
                    this.files = [...this.files, e];
              } else {
                  this.messageService.clear();
                  this.messageService.add({
                      severity: 'warn',
                      summary: 'File Type',
                      detail: 'Only .pptx/ .docx/ .pdf/ .txt/ .xls/ .xlsx/.csv files are allowed',
                  });
              }
          });
      }
      if (this.files.length > 0) {
          this.saveFile();
      }
  }

  checkExcelChat(type:string){
    let strucutredDocs = 0;
    let pdfDocs = 0
    let isValid = true;
    this.documentsList.forEach((e:IDocument)=>{
      if(this.excelType.includes(e.contentType)|| this.csvType.includes(e.contentType)){
        strucutredDocs += 1
      }else{
        pdfDocs += 1
      }
    })
    if(pdfDocs > 0 && (this.excelType.includes(type)|| this.csvType.includes(type))){
      isValid = false;
      this.messageService.add({
        severity:'error',
        summary:'File upload',
        detail:'Sorry ! You can’t upload a CSV here as you are already chatting with a PDF.Please remove the PDF file and then try to attach a CSV'
      })
    }
    return isValid;
  }

  onDragOver(event: DragEvent) {
      event.preventDefault();
      event.stopPropagation();
  }

  onDrop(event: DragEvent) {
      event.preventDefault();
      event.stopPropagation();
      const dt = event.dataTransfer;
      if (dt.items) {
        const items = Array.from(dt.items);
        let fileCount = 0;
        for (const item of items) {
            if (item.kind === 'file') {
                fileCount++;
            }
        }

        if (fileCount > 10) {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'File Limit Exceeded',
                detail: 'You can upload a maximum of 10 files at a time.',
            });
            return;
        }

          for (const item of items) {
              if (item.kind === 'file') {
                  const file = item.getAsFile();
                  if (ALL_DOCUMENT_FILE_FORMATS.includes(file.type)) {
                      this.files = [...this.files, file];
                  } else {
                      this.messageService.clear();
                      this.messageService.add({
                          severity: 'warn',
                          summary: 'File Type',
                          detail: 'Only .pptx/ .docx/ .pdf/ .txt/ .xls/ .xlsx/.csv files are allowed',
                      });
                  }
              }
          }
          this.saveFile();
      }
  }

  async checkExcelTables(selectedDocs: IDocument[] | []){
    this.selectedDocs = selectedDocs
    let showFileUpload = false;
    this.CSVTablesData = {}
    await Promise.all( this.CSVFiles.map(async (csv:IDocument)=>{
    if(this.excelType.includes(csv.contentType)){
      this.CSVTablesData[csv.documentName] = []
      let tableslength = 0;
      let documentTableMetaData :any = {}
      if(csv.documentMetaData){
        documentTableMetaData = csv.documentMetaData
      }
      else{
        await new Promise<void>((resolve, reject) => {
          this.docService.getTablesFromExcel(csv.documentId).subscribe({
            next: (res: any) => {
              if(res){
                documentTableMetaData = res
              }
              resolve();
            },
            error: (error) => {
              reject(error);
            }
          })
        })
      }
      let tableNames = []
      if(Object.keys(documentTableMetaData).length > 0){
        Object.keys(documentTableMetaData).forEach((e:string,i:number)=>{
          tableNames[i] = {
              doc : csv,
              sheet:e,
              fileName: csv.documentName,
              tables : documentTableMetaData[e].map((e:any)=>e.tableName),
              selectedTables : undefined
              }
            })
          this.CSVTablesData[csv.documentName] = tableNames;
      }
   }
    }));
    let showUploadDialog =  false;
    this.CSVFiles.forEach((csv:IDocument)=>{
      if( !this.activeChat?.chatDocument?.some(doc => doc.documentId.includes(csv.documentId))){
        if(this.CSVTablesData[csv.documentName]?.length > 1 || 
            (this.CSVTablesData[csv.documentName]?.length == 1 && this.CSVTablesData[csv.documentName][0]['tables'].length > 1)){
          showUploadDialog = true
        }
      }
    })

    if(showUploadDialog || showFileUpload){
      showFileUpload = true
      if(showFileUpload){
        this.CSVFilesCopy = structuredClone(this.CSVFiles);
        this.displayCSVUploadDialog = true
      }
    }
    else{
        let allDocsData : IChatDocument[]=[]
        this.CSVFiles.forEach((csv:IDocument)=>{
        let tempmetaData : IChatMetaData[]=[]
        let tempChatDoc : IChatDocument = {
          documentId : csv.documentId,
          documentName : csv.documentName,
          contentType : csv.contentType,
        }
        if(this.CSVTablesData[csv.documentName]){
          this.CSVTablesData[csv.documentName].forEach((sheets:any)=>{
            sheets.tables.forEach((table:any)=>{
              let tempTable :IChatMetaData ={
                sheetName : sheets.sheet,
                tableName : table
              }
              tempmetaData.push(tempTable)
            })
          })
          tempChatDoc['metaData']=tempmetaData
        }
              allDocsData.push(tempChatDoc)
        })
        let DocsPayload:IChatDocument[]=[]
        if(selectedDocs.length > this.CSVFiles.length){
          let StructuredDocsIdentifiers = new Set(allDocsData.map(doc => `${doc.documentId}-${doc.documentName}`));
          let uniqueDocs = new Set<string>();
          selectedDocs.forEach((e: IDocument) => {
              if (e.type !== UploadType.Folder) {
                  let uniqueIdentifier = `${e.documentId}-${e.documentName}`;
                  if (!StructuredDocsIdentifiers.has(uniqueIdentifier) && !uniqueDocs.has(uniqueIdentifier)) {
                      uniqueDocs.add(uniqueIdentifier);
                      DocsPayload.push({
                          documentId: e.documentId,
                          documentName: e.documentName,
                          contentType: e.contentType
                      });
                  }
              }
          });
        }
        this.attachChatstoDocs([...allDocsData,...DocsPayload])
    }
  }

  submitFileUploadDialog(excelDocs: IChatDocument[]) {
    const action = () => {
        this.displayCSVUploadDialog = false;
        let DocsPayload: IChatDocument[] = [];
        let StructuredDocsIdentifiers = new Set(excelDocs.map(doc => `${doc.documentId}-${doc.documentName}`));
        let uniqueDocs = new Set<string>();
        this.selectedDocs.forEach((e: IDocument) => {
            if (e.type !== UploadType.Folder) {
                let uniqueIdentifier = `${e.documentId}-${e.documentName}`;
                if (!StructuredDocsIdentifiers.has(uniqueIdentifier) && !uniqueDocs.has(uniqueIdentifier)) {
                    uniqueDocs.add(uniqueIdentifier);
                    DocsPayload.push({
                        documentId: e.documentId,
                        documentName: e.documentName,
                        contentType: e.contentType
                    });
                }
            }
        });
        this.attachChatstoDocs([...excelDocs, ...DocsPayload]);
    };

    if (this.isUploading || this.countDocProcessing > 0) {
        this.chatUpdateQueue.push(action);
        this.displayCSVUploadDialog = false;
        this.messageService.clear();
        this.messageService.add({
            severity: 'info',
            summary: 'Queued',
            detail: 'Your table selections are queued and will be processed after current uploads complete.',
            life: 3000
        });
    } else {
        action();
    }
  }

  private async associateDocsWithChat(docs: IDocument[]) {
    if (docs.length === 0) {
        return;
    }

    const chatInfo = this.activeChat;
    const excelFiles = docs.filter(d => this.excelType.includes(d.contentType) || this.csvType.includes(d.contentType));

    if (excelFiles.length > 0) {
        this.CSVFiles.push(...excelFiles.filter(ef => !this.CSVFiles.some(cf => cf.documentId === ef.documentId)));
        await this.checkExcelTables(this.documentsList);
    } else {
        const existingDocs = chatInfo?.chatDocument || [];
        
        const newDocsPayload: IChatDocument[] = docs.map(d => ({
            documentId: d.documentId,
            documentName: d.documentName,
            contentType: d.contentType
        }));

        // Filter out duplicates that might already be in the chat from a previous operation
        const finalPayload = [...existingDocs, ...newDocsPayload.filter(nd => !existingDocs.some(ed => ed.documentId === nd.documentId))];

        this.updateChatsSub.add(
            this.chatServices.updateChatDocuments(finalPayload, chatInfo.chatId).subscribe({
                next: (res) => {
                    this.activeChat = res?.data;
                    this.chatServices.updateActiveChatObs(res?.data);
                    this.chatServices.updateActiveChat(res?.data);
                    // update the current document list too
                    this.getChatDocuments()
                    // Now that chat is updated, start polling for all newly uploaded documents
                    docs.forEach(doc => this.longPollDocs(doc.documentId, chatInfo));
                },
                error: (error) => {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error associating documents',
                        detail: error.error.message,
                    });
                    // Even if association fails, we should update the processing count
                    this.getProcessingDocsCount();
                }
            })
        );
    }
  }

  saveFile(forceUpload?: boolean) {
    let filesToEnqueue = this.files;
    if (forceUpload) {
        filesToEnqueue = this.identicalHashFiles;
        this.identicalHashFiles = [];
        this.messageService.clear();
        this.messageService.add({
            severity: 'info',
            summary: 'Uploading files',
            detail: `${filesToEnqueue.length} duplicate file(s) will now be uploaded`,
        });
    }
    this.files = [];

    if (filesToEnqueue.length > 0) {
        const items = filesToEnqueue.map(f => ({ file: f, force: !!forceUpload }));
        this.uploadQueue.push(...items);
        this.processUploadQueue();
    }
  }

  async processUploadQueue() {
    if (this.isUploading || this.uploadQueue.length === 0 || this.countDocProcessing > 0) {
        return;
    }

    this.isUploading = true;

    try {
        if (!this.activeChat?.chatId) {
            await new Promise<void>((resolve, reject) => {
                this.createChatSub.add(
                    this.chatServices.createNewChat().subscribe({
                        next: (res: IChat) => {
                            this.activeChat = res;
                            this.isloading = false;
                            this.chatServices.updateActiveChatObs(res);
                            this.chatServices.updateActiveChat(this.activeChat);
                            this.router.navigate(['/chat', getRouteParamChatType(this.currentChatType), this.activeChat.chatId]);
                            resolve();
                        },
                        error: (error) => {
                            this.messageService.clear();
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Error',
                                detail: error.error.message,
                            });
                            reject(error);
                        },
                    })
                );
            });
        }

        const itemsToUpload = this.uploadQueue.splice(0, this.uploadQueue.length);
        const filesToUpload = itemsToUpload.map(i => i.file);

        if (filesToUpload.length === 0) {
            return;
        }

        const placeholders: IDocument[] = filesToUpload.map(file => ({
            documentId: '',
            documentName: file.name,
            blobPath: '',
            creatorId: '',
            creatorName: '',
            documentStatus: DocumentStatus.Processing,
            accessLevel: DocumentAccessLevel.Private,
            MD5: '',
            shortSummary: '',
            summaryStatus: SummaryStatus.New,
            contentType: file.type,
        }));

        this.documentsList.push(...placeholders);
        this.getProcessingDocsCount();
        this.cdr.detectChanges();

        const uploadPromises = itemsToUpload.map((item, index) => {
            const placeholder = placeholders[index];
            const formData = new FormData();
            formData.append('file', item.file);

            return new Promise<IDocument | null>((resolve) => {
                this.uploadSub.add(
                    this.chatServices.uploadFile(formData, item.force).subscribe({
                        next: (res: IDocument) => {
                            const docIndex = this.documentsList.findIndex(d => d.documentName === placeholder.documentName && d.documentId === '');
                            if (docIndex !== -1) {
                                this.documentsList[docIndex] = res;
                            }
                            resolve(res);
                        },
                        error: (error) => {
                            const docIndex = this.documentsList.findIndex(d => d.documentName === placeholder.documentName && d.documentId === '');
                            if (docIndex !== -1) {
                                this.documentsList.splice(docIndex, 1);
                                this.getProcessingDocsCount();
                                this.cdr.detectChanges();
                            }
                            
                            if (error.status === HttpStatusCodes.Conflict && error.error.message.includes('verify')) {
                                this.identicalHashFiles.push(item.file);
                                this.displayDialogType = 'verifyUpload';
                                this.dialogMessage = `Another identical file(s) had been detected. Are you sure you still want to upload ?`;
                                this.displayConfirmationDialog = true;
                            } else {
                                const detail = error.error?.message || 'An unknown error occurred during upload.';
                                this.messageService.add({ severity: 'error', summary: 'Error', detail });
                            }
                            resolve(null);
                        }
                    })
                );
            });
        });

        const uploadedDocs = (await Promise.all(uploadPromises)).filter((doc): doc is IDocument => doc !== null);
        
        if (uploadedDocs.length > 0) {
            await this.associateDocsWithChat(uploadedDocs);
        }

    } catch (error) {
        console.error('Failed to create chat or process upload queue', error);
    } finally {
        this.isUploading = false;
        this.getProcessingDocsCount();
        this.cdr.detectChanges();
        // if there are any duplicate hash files that needs uploading let them upload after normal files
        setTimeout(() => this.processUploadQueue(), 0);
    }
  }

  openRetriggerConfirmation(doc:IDocument,i:number){
      this.displayDialogType = 'retriggerUpload';
      this.dialogMessage = `Are you sure you want to retry the document upload ?`;
      this.displayConfirmationDialog = true;
      this.retriggerDoc=doc
      this.retriggerDocIndex=i
  }

  retriggerUpload(doc:IDocument,i:number){
    this.documentsList[i].documentStatus=DocumentStatus.Processing
    this.chatServices.updateChatDocumentList(this.documentsList)
    this.getProcessingDocsCount()
    this.chatServices.retriggerUploadFile(doc.documentId).subscribe({
        next:(res:IDocument)=>{
            this.documentsList[i]=res
            this.getProcessingDocsCount()
            this.chatServices.updateChatDocumentList(this.documentsList)
            if(res.documentStatus===DocumentStatus.Processing){
                this.longPollDocs(res.documentId, this.activeChat);
            }
        },
        error:(error)=>{
            this.documentsList[i]=doc
            this.getProcessingDocsCount()
            this.chatServices.updateChatDocumentList(this.documentsList)
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error.error.message,
            });
        }
    })
}

  ondialogaccept() {
      this.displayConfirmationDialog = false;
      if (this.displayDialogType === 'delete') {
          this.removeFile();
      }
      if (this.displayDialogType == 'retriggerUpload') {
          this.retriggerUpload(this.retriggerDoc,this.retriggerDocIndex);
      }
      if (this.displayDialogType == 'verifyUpload') {
        this.messageService.clear();
        this.messageService.add({
            severity: 'info',
            summary: 'Queued',
            detail: 'Document(s) will be uploaded once all other files are uploaded',
            life:5000
        });
        this.saveFile(true);
      }
  }
  onCancelDialog() {
      this.displayConfirmationDialog = false;
      if (this.displayDialogType == 'verifyUpload') {
          this.identicalHashFiles = [];
      }
  }
  deleteConfirmationDialog(element: IChatDocument, i: number) {
      this.displayDialogType = 'delete';
      this.dialogMessage = `Are you sure you want to remove ${element.documentName} ?`;
      this.displayConfirmationDialog = true;
      this.deletingDoc = element;
      this.deletingDocIndex = i;
  }

  removeFile() {
      let tempDoc: IChatDocument = this.deletingDoc;
      this.deleteDocsSub.add(
          this.chatServices
              .deleteChatDocs(this.activeChat.chatId, tempDoc.documentId)
              .subscribe({
                  next: (res) => {
                      this.documentsList.forEach(
                          (item: IDocument, i: number): void => {
                              if (item.documentId == tempDoc.documentId) {
                                  this.documentsList.splice(i, 1);
                                  this.chatServices.updateChatDocumentList(this.documentsList)
                                  this.getProcessingDocsCount()

                              }
                          }
                      );
                      this.activeChat.chatDocument.forEach((e:IChatDocument,idx:number)=>{
                          if (e.documentId == tempDoc.documentId) {
                              this.activeChat.chatDocument.splice(idx, 1);
                          }
                      })
                      this.messageService.clear();
                      this.messageService.add({
                          severity: 'success',
                          summary: 'Success',
                          detail: 'Document is successfully removed from the chat',
                      });
                  },
                  error: (error) => {
                      this.messageService.clear();
                      this.messageService.add({
                          severity: 'error',
                          summary: 'Error',
                          detail: error.error.message,
                      });
                  },
              })
      );
  }

  getChatDocuments() {
      if (this.activeChat === undefined) {
          this.activeChat = this.chatServices.getActiveChat();
      } else {
          this.isloading = true;
      }
      let chatInfo = this.activeChat;
      this.getChatDocsSub = this.chatServices
          .getChatDocuments(this.activeChat?.chatId)
          .subscribe({
              next: (res: IDocument[]) => {
                  this.isloading = false;

                  const resDocsMap = new Map(res.map(doc => [doc.documentId, doc]));

                  // Update existing docs and remove deleted ones
                  for (let i = this.documentsList.length - 1; i >= 0; i--) {
                      const doc = this.documentsList[i];

                      if (doc.documentId === '') {
                          continue; // Keep placeholders for uploading files
                      }

                      const updatedDoc = resDocsMap.get(doc.documentId);
                      if (updatedDoc) {
                          Object.assign(doc, updatedDoc); // Update in place
                          resDocsMap.delete(doc.documentId); // Remove from map
                      } else {
                          this.documentsList.splice(i, 1); // Remove if not in new list
                      }
                  }

                  // Add new docs from the server
                  resDocsMap.forEach(newDoc => {
                      this.documentsList.push(newDoc);
                  });

                  this.getProcessingDocsCount()
                  this.chatServices.updateChatDocumentList(this.documentsList)
                  let islongpooling=false;
                  this.CSVFiles = this.documentsList.filter(x=> this.excelType.includes(x.contentType) || this.csvType.includes(x.contentType));
                  this.documentsList.forEach((e: IDocument) => {
                      if (e.documentStatus === DocumentStatus.Processing || e.documentStatus === DocumentStatus.Converting  || e.documentStatus === DocumentStatus.TextOnly ||
                        (e.structuredDocumentStatus && e.structuredDocumentStatus === DocumentStatus.Processing) ||
                        (this.excelType.includes(e.contentType) && !e.structuredDocumentStatus) ) {
                          islongpooling=true
                          this.longPollDocs(e.documentId, chatInfo);
                      }
                  });
                  if(!islongpooling){
                  this.reloadInteractions.emit('stop');
                  }
              },error(err) {
                  this.isloading = false;
                  this.reloadInteractions.emit('stop');
              },
          });
  }

    longPollDocs(docId: string, chatInfo: IChat) {
        if (this.pollingSet.has(docId) || this.activeChat?.chatId !== chatInfo.chatId || docId == '') {
            return;
        }
        this.pollingSet.add(docId);
        this.performLongPoll(docId, chatInfo);
    }

    private performLongPoll(docId: string, chatInfo: IChat) {
        if (this.activeChat?.chatId !== chatInfo.chatId) {
            this.pollingSet.delete(docId);
            return;
        }

        const docInList = this.documentsList.find(d => d.documentId === docId);
        const contentType = docInList?.contentType || this.activeChat.chatDocument.find(d => d.documentId === docId)?.contentType;

        let handled = false;
        this.longPollSub.add(
            this.chatServices.getDocumentDetails(docId, chatInfo.chatId, contentType).subscribe({
                next: (res: IDocument) => {
                    handled = true;
                    const docIndex = this.documentsList.findIndex(d => d.documentId === res.documentId);
                    if (docIndex !== -1) {
                        this.documentsList[docIndex] = res;
                        this.chatServices.updateChatDocumentList(this.documentsList);
                        this.getProcessingDocsCount();
                        this.cdr.detectChanges();
                    }

                    const isStillProcessing = res.documentStatus === DocumentStatus.Processing ||
                                            res.documentStatus === DocumentStatus.Converting ||
                                            res.documentStatus === DocumentStatus.TextOnly ||
                                            (res.structuredDocumentStatus && res.structuredDocumentStatus === DocumentStatus.Processing) ||
                                            (this.excelType.includes(res.contentType) && !res.structuredDocumentStatus);

                    if (isStillProcessing) {
                        setTimeout(() => this.performLongPoll(docId, chatInfo), 5000);
                    } else {
                        this.pollingSet.delete(docId);
                        this.handleSuccessfulProcessing(res, chatInfo);
                    }
                    this.getProcessingDocsCount();
                    this.cdr.detectChanges();
                },
                error: (error) => {
                    handled = true;
                    this.pollingSet.delete(docId);
                    const docIndex = this.documentsList.findIndex(d => d.documentId === docId);
                    if (docIndex !== -1) {
                        this.documentsList[docIndex].documentStatus = DocumentStatus.Failed;
                        this.chatServices.updateChatDocumentList(this.documentsList);
                        this.getProcessingDocsCount();
                    }
                    this.cdr.detectChanges();
                },
                complete: () => {
                    if (!handled) {
                        this.pollingSet.delete(docId);
                        const docIndex = this.documentsList.findIndex(d => d.documentId === docId);
                        if (docIndex !== -1) {
                            this.documentsList[docIndex].documentStatus = DocumentStatus.Failed;
                            this.chatServices.updateChatDocumentList(this.documentsList);
                            this.getProcessingDocsCount();
                        }
                        this.cdr.detectChanges();
                    }
                }
            })
        );
    }

    private handleSuccessfulProcessing(doc: IDocument, chatInfo: IChat) {
        const isFullyProcessed = (doc.documentStatus === DocumentStatus.Processed && !doc.structuredDocumentStatus) ||
                                 (doc.documentStatus === DocumentStatus.Processed && doc.structuredDocumentStatus === DocumentStatus.Processed);

        if (!isFullyProcessed) {
            this.getProcessingDocsCount();
            return;
        }

        const isStructuredDoc = this.excelType.includes(doc.contentType) || this.csvType.includes(doc.contentType);

        if (isStructuredDoc) {
            this.reloadInteractions.emit('showLoader');
        }

        this.chatServices.getchatById(chatInfo.chatId).subscribe({
            next: (latestChat: IChat) => {
                const chatDoc = latestChat.chatDocument?.find(cd => cd.documentId === doc.documentId);
                const needsSummary = !chatDoc?.generatedSummary;

                if (isStructuredDoc) {
                    if (needsSummary) {
                        this.getSummaryForDocument(doc, chatInfo);
                    } else {
                        this.reloadInteractions.emit('summary');
                        if (latestChat?.chatDocument?.length > 0) {
                            this.reloadInteractions.emit('loadChatHistory');
                        }
                        if (this.countDocProcessing === 0 && this.pollingSet.size === 0) {
                            this.reloadInteractions.emit('stop');
                        }
                    }
                } else if (this.countDocProcessing === 0 && this.pollingSet.size === 0) {
                    this.reloadInteractions.emit('stop');
                    if (latestChat?.chatDocument?.length > 0) {
                        this.reloadInteractions.emit('loadChatHistory');
                    }
                }
                
            },
            error: (err) => {
                this.reloadInteractions.emit('stop');
            }
        });
    }

    private getSummaryForDocument(doc: IDocument, chatInfo: IChat) {
        this.docSummarySub.add(
            this.chatServices.sendQuestion(' ', chatInfo.chatId, InteractionType.SUMMARY).subscribe({
                next: (interaction: IChatInteraction) => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Document is uploaded successfully' });
                    const chatTypeForSummary = this.excelType.includes(doc.contentType) || this.csvType.includes(doc.contentType)
                        ? ChatType.StructuredDocument
                        : ChatType.UnstructuredDocument;
                        this.docSummarySub.add(
                            this.chatServices.getQuestionResponseSummary(chatInfo.chatId, interaction.interactionId, doc.documentId, chatTypeForSummary, this.activeChat?.selectedModel ?? null).subscribe({
                                next: () => {
                                    if (chatInfo.chatId === this.activeChat?.chatId) {
                                        this.reloadInteractions.emit('summary');
                                        if (chatInfo?.chatDocument?.length > 0) {
                                            this.reloadInteractions.emit('loadChatHistory');
                                        }
                                    }
                                },
                                error: (error) => {
                                    this.reloadInteractions.emit('stop');
                                    this.messageService.add({ severity: 'error', summary: 'Summary Error', detail: error.error.message });
                                },
                                complete: () => {
                                    if (this.countDocProcessing === 0 && this.pollingSet.size === 0) {
                                        this.reloadInteractions.emit('stop');
                                    }
                                }
                            })
                        );
                },
                error: (error) => {
                    this.reloadInteractions.emit('stop');
                    this.messageService.add({ severity: 'error', summary: 'Upload Error', detail: error.error.message });
                }
            })
        );
    }

    private processChatUpdateQueue() {
        if (this.isUploading || this.countDocProcessing > 0 || this.chatUpdateQueue.length === 0) {
            return;
        }
        const updateAction = this.chatUpdateQueue.shift();
        if (updateAction) {
            this.messageService.clear();
            this.messageService.add({
                severity: 'info',
                summary: 'Updating Table(s)',
                detail: 'Updating selected tables from excel file(s)',
                life: 5000,
            });
            updateAction();
        }
    }

    getProcessingDocsCount() {
        let processingCount = 0;
        if (
            this.documentsList?.length > 0 &&
            this.activeChat?.chatState !== ChatState.InActive &&
            this.activeChat?.chatState !== ChatState.Archived
        ) {
            const allProcessingDocs = this.documentsList.filter(docItem =>
                docItem.documentStatus === DocumentStatus.Processing ||
                docItem.documentStatus === DocumentStatus.Converting ||
                docItem.documentStatus === DocumentStatus.TextOnly ||
                (docItem.structuredDocumentStatus && docItem.structuredDocumentStatus === DocumentStatus.Processing) ||
                (this.excelType.includes(docItem.contentType) && !docItem.structuredDocumentStatus) ||
                docItem.documentId === ""
            );

            allProcessingDocs.forEach(doc => {
                this.longPollDocs(doc.documentId, this.chatServices.getActiveChat());
            });

            const uiBlockingDocs = allProcessingDocs.filter(docItem =>
                docItem.documentStatus !== DocumentStatus.TextOnly
            );
            
            processingCount = uiBlockingDocs.length;
        }
        
        this.countDocProcessing = processingCount;
        this.chatDocsProcessingCount.emit(this.countDocProcessing);

        if (this.countDocProcessing > 0) {
            this.reloadInteractions.emit('showLoader');
        } else if (this.pollingSet.size === 0) {
            this.reloadInteractions.emit('stop');
        }

        if (this.countDocProcessing === 0) {
            this.processUploadQueue();
            this.processChatUpdateQueue();
        }
    }


  getchatInteractionCount(chatInteractionsCount:number){
    this.chatInteractionCount = chatInteractionsCount
  }

  trackByDocumentName(index: number, document: IDocument): string {
    return document.documentName;
  }

  checkChatType(event:any){
    if(event === ChatType.ESG){
      this.isloading = false
    }
    if(event === ChatType.HRDocuments && this.hrDocuments.length == 0){
      this.isloading=true
      this.getHRDocuments()
    }
  }



  //ESG Chat

  async updateESGFilters(event:any,hideloading?:boolean){
    if(!hideloading){
      this.isloading = true
    }
    this.reloadInteractions.emit('showLoader');
    let selectedTags :ITableTag[] = event.Tags || []
    let selectedTables :IDeltaTable[] = event.deltaTables || []
    let chatConfig: IChatConfig = {}
    this.sidebarVisible = false;
    if(event.SourceType || event.DocumentName){
      let tempESGConfig:IESGConfig = {
        ESGSources : event.SourceType || [],
        ESGDocuments : event.DocumentName || []
      }
      chatConfig.ESGChat =tempESGConfig
    }
    if(this.activeChat?.chatId){
      this.updateChatsSub?.unsubscribe()
      this.updateChatsSub = new Subscription()
      this.updateChatsSub.add(
          this.chatServices
              .updateChatDocuments(
                  [],
                  this.activeChat.chatId,selectedTables,selectedTags,chatConfig
              )
              .subscribe({
                  next: (res:IAddDoctoChatAPIResp) => {
                    this.isloading = false
                    this.activeChat = res.data
                    this.ESGDocumentLoaderDocs = {}
                    this.ESGDeletionLoaderTags = {}
                    this.ESGDeletionLoaderSources = {}
                    this.chatServices.updateActiveChatObs(res.data);
                    this.chatServices.updateActiveChat(this.activeChat);
                    this.reloadInteractions.emit('stop');
                  },
                  error: (error) => {
                    this.reloadInteractions.emit('stop');
                          this.messageService.clear();
                          this.messageService.add({
                              severity: 'error',
                              summary: 'Error',
                              detail: error.error.message,
                          });
                  },
              })
      );}else{
        this.createChatSub.add(
          this.chatServices.createNewChat().subscribe({
              next: (res: IChat) => {
                  this.activeChat = res;
                  this.updateESGFilters(event);
                  this.router.navigate(['/chat', getRouteParamChatType(this.currentChatType), this.activeChat.chatId]);

              },
              error: (error) => {
                this.reloadInteractions.emit('stop');
                  this.messageService.clear();
                  this.messageService.add({
                      severity: 'error',
                      summary: 'Error',
                      detail: error.error.message,
                  });
              },
          })
      );
      }
  }

  deleteChatESGDocs(document:ISourceURL, idx:number){
    this.ESGDocumentLoaderDocs[idx]= true
    const ESGFilter :Record<string,any> ={}
    if(this.activeChat?.chatConfig?.ESGChat){
        const deletionSource = document.sourceType
        let countSourceTypeDocs = 0
        let updatedDocs:ISourceURL[] = []
        this.activeChat.chatConfig?.ESGChat?.ESGDocuments.forEach((e:ISourceURL)=>{
          if(e.sourceType === deletionSource){
            countSourceTypeDocs +=1
          }
          if(document.documentPath !== e.documentPath){
            updatedDocs.push(e)
          }
        })
        if(countSourceTypeDocs==1){
          ESGFilter['SourceType'] = this.activeChat.chatConfig?.ESGChat?.ESGSources?.filter(e=>e.sourceType !== deletionSource)
        }else{
          ESGFilter['SourceType'] = this.activeChat.chatConfig?.ESGChat?.ESGSources
        }
        ESGFilter['DocumentName'] = updatedDocs
        ESGFilter['Tags'] = this.activeChat.ESGTableTags
        this.updateESGFilters(ESGFilter, true)
    }
  }

  deleteESGTags(tag:ITableTag, idx:number){
    this.ESGDeletionLoaderTags[idx]= true
    const ESGFilter :Record<string,any> ={
      'Tags' : this.activeChat?.ESGTableTags?.filter(e=>e!=tag),
    }
    if(this.activeChat?.chatConfig?.ESGChat){
      ESGFilter['SourceType'] = this.activeChat.chatConfig?.ESGChat?.ESGSources
      ESGFilter['DocumentName'] = this.activeChat.chatConfig?.ESGChat?.ESGDocuments
    }
    this.updateESGFilters(ESGFilter, true)
  }

  deleteESGSources(source:ISourceURL, idx:number){
    this.ESGDeletionLoaderSources[idx]= true
    const ESGFilter :Record<string,any> ={
      'Tags' : this.activeChat?.ESGTableTags || [],
    }
    if(this.activeChat?.chatConfig?.ESGChat){
      ESGFilter['SourceType'] = this.activeChat.chatConfig?.ESGChat?.ESGSources.filter(e=>e.sourceType!=source.sourceType)
      ESGFilter['DocumentName'] = this.activeChat.chatConfig?.ESGChat?.ESGDocuments.filter(e=>e.sourceType !== source.sourceType)
    }
    this.updateESGFilters(ESGFilter, true)
  }

  async deleteChatTables(table: IDeltaTable, idx: number) {
    this.tablesLoaderDocs[idx] = true;

    // Handle Pre Selected WFDO Tables
    if(!this.activeChat?.chatId && this.chatServices.chatType === ChatType.QEC) {
        this.tablesLoaderDocs[idx] = false;
        this.docService.setDefaultWFDOTablesList(this.docService.defaultWFDOTables.filter(e => e.tableName !== table.tableName));
        return;
    }


    if (this.activeChat?.chatTables) {
        await this.delay(500);
        this.activeChat.chatTables = this.activeChat.chatTables.filter(e => e.tableName !== table.tableName);
        this.tablesLoaderDocs[idx] = false;
    }

    this.updateChatTables(this.activeChat.chatTables, idx);
}

// Utility method for delay
private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
}

  updateChatTables(chatTables:IDeltaTable[],idx:number){
    this.updateChatTablesSub.add(
      this.chatServices
          .updateChatDocuments([],
              this.activeChat.chatId,
              chatTables
          )
          .subscribe({
              next: (res) => {
                  this.activeChat = res?.data;
                  this.chatServices.updateActiveChatObs(res?.data);
                  this.chatServices.updateActiveChat(res?.data);
                  if(res?.message?.trim() != ''){
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: res?.message,
                    });
                  }
              },
              error: (error) => {
                  this.messageService.clear();
                  this.messageService.add({
                      severity: 'error',
                      summary: 'Error',
                      detail: error.error.message,
                  });
              },
          })
  );
  }


  getHRDocuments(){
    this.hrDocsSubscription.add(
      this.chatServices.getHRDocuments().subscribe({
          next: (res: IChatDocument[]) => {
              if(res.length>0){
                this.hrDocuments = res
              }
              this.isloading =false
          },
          error: (error) => {
              this.isloading =false
            },
        })
    );
  }

}
